import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'
import integrationsData from '@core/api/data/integrations.json'
import {
	IntegrationResponseDTO,
	IntegrationsListResponseDTO,
} from '@core/api/dtos/response/integration/integration'
import { IntegrationFilters } from '@core/api/entities/integration'

import { IntegrateRequestDTO } from '../dtos/request/integration/integrate'

// Transform JSON data to match DTO structure
const transformIntegrationData = (item: any): IntegrationResponseDTO => {
	return {
		type: item.type,
		name: item.name,
		icon: item.icon,
		modal_title: item.modal_title,
		modal_content: item.modal_content,
		modal_submit: item.modal_submit,
		modal_cancel: item.modal_cancel,
		typeform_url: item.typeform_url,
	}
}

class IntegrationService {
	async getIntegrations(
		filters?: IntegrationFilters
	): Promise<{ data: IntegrationsListResponseDTO }> {
		// Transform all integrations
		let transformedIntegrations = integrationsData.map(transformIntegrationData)

		// Apply filters
		if (filters?.search) {
			const searchTerm = filters.search.toLowerCase()
			transformedIntegrations = transformedIntegrations.filter(
				(integration) =>
					integration.name.toLowerCase().includes(searchTerm) ||
					integration.modal_content?.toLowerCase().includes(searchTerm)
			)
		}

		// Simulate pagination (you can add actual pagination logic if needed)
		const page = 1
		const limit = transformedIntegrations.length
		const total = transformedIntegrations.length

		const response: IntegrationsListResponseDTO = {
			data: transformedIntegrations,
			meta: {
				total,
				page,
				limit,
			},
		}

		return Promise.resolve({ data: response })
	}

	/**
	 * Integrate with an integration or addon
	 */
	integrate(
		data: IntegrateRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post('/accounts/smart/integrate', data, config)
	}
}

export default new IntegrationService()
